import type { MarketplaceErrorRes } from '@dvb/common';

import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function SportRecordDetailError({
  error,
}: {
  error: Error | MarketplaceErrorRes;
}) {
  const { t } = useTranslation();

  const { description, title } = useMemo(() => {
    if ('code' in error && error.code === 2001) {
      return {
        description: t('notFoundDes', { name: t('record') }),
        title: t('notFound', { name: t('record') }),
      };
    }
    return { description: '', title: '' };
  }, [error, t]);

  return (
    <>
      <HeaderBar hasBackBtn title={t('recordDetail')} />
      <BaseErrorLayout
        className="bg-background w-full"
        description={description}
        title={title}
      />
    </>
  );
}
